export default __webpack_public_path__ + "static/media/nice_logo_white.a4982ed0.png";